// Analytics utilities for Google Analytics 4 and Facebook Pixel

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    fbq: (...args: any[]) => void;
  }
}

export const trackGA4Event = (
  eventName: string,
  params?: Record<string, any>
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

export const trackFBEvent = (
  eventName: string,
  params?: Record<string, any>
) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
};

export const trackLead = (data?: {
  name?: string;
  email?: string;
  phone?: string;
  variant?: string;
}) => {
  const contentName = data?.variant === 'call-center' ? 'AI Call Center - Kwalifikacja' : 'AI Cold Caller - Kwalifikacja';

  trackGA4Event('generate_lead', {
    currency: 'PLN',
    value: 0,
    content_name: contentName,
  });

  trackFBEvent('Lead', {
    content_name: contentName,
    content_category: 'Booking Form',
  });

  console.log('[Analytics] Lead conversion tracked:', contentName);
};

export const trackBookingModalOpen = () => {
  trackGA4Event('begin_checkout', {
    currency: 'PLN',
    value: 0,
  });

  trackFBEvent('InitiateCheckout', {
    content_name: 'Booking Modal',
  });
};

export const trackButtonClick = (buttonName: string) => {
  trackGA4Event('select_content', {
    content_type: 'button',
    content_id: buttonName,
  });
};

export const trackViewContent = (variant?: string) => {
  const pageName = variant === 'call-center' ? 'AI Call Center Landing Page' : 'AI Cold Caller Landing Page';

  trackFBEvent('ViewContent', {
    content_name: pageName,
    content_category: 'Landing Page',
  });

  trackGA4Event('view_item', {
    item_name: pageName,
  });
};

export const trackScrollDepth = (percentage: number) => {
  trackGA4Event('scroll', {
    percent_scrolled: percentage,
  });

  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', `ScrollDepth${percentage}`, {
      percent: percentage,
    });
  }
};

export const trackTimeOnPage = (seconds: number) => {
  trackGA4Event('timing_complete', {
    name: 'time_on_page',
    value: seconds,
  });

  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', `TimeOnPage${seconds}s`, {
      seconds: seconds,
    });
  }
};

export const initEngagementTracking = (variant?: string) => {
  if (typeof window === 'undefined') return;

  setTimeout(() => {
    trackViewContent(variant);
  }, 2000);

  const scrollThresholds = [50, 75, 90];
  const triggeredScrolls = new Set<number>();

  const handleScroll = () => {
    const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = Math.round((window.scrollY / scrollHeight) * 100);

    scrollThresholds.forEach((threshold) => {
      if (scrollPercent >= threshold && !triggeredScrolls.has(threshold)) {
        triggeredScrolls.add(threshold);
        trackScrollDepth(threshold);
      }
    });
  };

  window.addEventListener('scroll', handleScroll, { passive: true });

  const timeThresholds = [30, 60, 120];
  timeThresholds.forEach((seconds) => {
    setTimeout(() => {
      trackTimeOnPage(seconds);
    }, seconds * 1000);
  });
};
